// counter.ts
import * as companyAnalysis from '../actions/company-analysis.actions';
import { CompanyAnalysis } from '../models/company-analysis.model';

export interface State {
  filter: object;
  searchError: boolean
  isFetching: boolean;
  ref: string;
  searches: {
    [ref: string]: {
      name: string;
      filter: object;
      isFetching: boolean;
      total: number;
      limit: number;
      offset: number;
      error: boolean;
      config: object;
      results: CompanyAnalysis[]
    }
  }
}

export const initialState: any = {
  filter: {},
  isFetching: false,
  searches:{
    upper: {
      config: { filter: {}, limit: 5, sort: { "priceChangePercent": 1 } },
      results: []
    },
    lower: {
      config: { filter: {}, limit: 5, sort: { "priceChangePercent": -1 } },
      results: []
    },
    all: {
      config: { filter: {}, limit: 25, sort: { "name": 1 } },
      results: []
    }
  },
  searchError: false
};

export function reducer(state: State = initialState, action: companyAnalysis.Actions): State {
  let searches;
  switch (action.type) {

    case companyAnalysis.SET_FILTERED_RESULTS_CONFIG:
      state.searches.filteredResults.config = action.payload;
      return JSON.parse(JSON.stringify(state));

    case companyAnalysis.CLEAR_FILTERED_RESULTS_CONFIG:
      state.searches.filteredResults.config = initialState.searches.filteredResults;
      return JSON.parse(JSON.stringify(state));

    case companyAnalysis.FETCH_ANALYSIS:
      state.isFetching = true;
      state.searches[action.payload.ref]=action.payload;
      state.searches[action.payload.ref].name = action.payload.name;
      state.searches[action.payload.ref].isFetching = true;
      state.searches[action.payload.ref].error = false;
      state.searches[action.payload.ref].results = null;
      state.searches[action.payload.ref].config = action.payload.config;
      return JSON.parse(JSON.stringify(state));

    case companyAnalysis.FETCH_ANALYSIS_SUCCESS:
      state.isFetching = false;
      state.searches[action.payload.ref].isFetching = false;
      state.searches[action.payload.ref].error = false;
      state.searches[action.payload.ref].results = action.payload.companies;
      return JSON.parse(JSON.stringify(state));

    case companyAnalysis.FETCH_ANALYSIS_FAILURE:
      state.isFetching = false;
      searches = Object.assign({}
        , state.searches
        , { [action.payload.ref]: { isFetching: false, data: null, error: true } });
      return Object.assign({}
        , state
        , { searches });
    default:
      return JSON.parse(JSON.stringify(state));
  }
}

export const getCompanyAnalysis = (state: State) => state.searches;
export const getUpper = (state: State) => state.searches.upper;
export const getLower = (state: State) => state.searches.lower;
export const getAll = (state: State) => state.searches.all;
export const getFilteredResults = (state: State) => state.searches.filteredResults;
export const getFilteredResultsConfig = (state: State) => state.searches.filteredResults.config;





// WEBPACK FOOTER //
// ./src/reducers/company-analysis.reducer.ts